import 'babel-polyfill';
import { render } from 'react-native';
import { Root } from './root';
import React from 'react';

try {
  if (module.hot !== undefined) module.hot.accept();
} catch(e) {}

render(<Root />, document.getElementById('app'));